import { schema } from 'normalizr';

export const generalDashboardSchema = new schema.Entity('generalDashboard', {}, { idAttribute: 'ProductId' });

export const generalDashboardListSchema = [generalDashboardSchema];
